module.exports = __webpack_public_path__ + "img/bg_police_03.ef985caa.png";